import type { BeforeRequestHook } from 'ky';

import {
  I18N_ROUTER_LOCALE_HEADER_NAME,
  i18nConfig,
  LANGUAGE_ID_BY_LOCALE,
  LANGUAGE_ID_HEADER_NAME,
} from '../constants';

import { getLocaleFromCookie, getLocaleFromRequestCookieHeaders } from './manage-locale-cookie';

/**
 * A hook-interceptor that sets the `language_id` Request header based on the "Cookie" (`locale`) Request header
 * (for calls made from the Server Components or during SSR) or based on the browser `locale` cookie
 * for client-side calls
 */
export const setLanguageIdToRequestHeaders: BeforeRequestHook = (request) => {
  const shouldTakeCookieFromRequestHeaders = typeof window === 'undefined' || 'Deno' in globalThis;

  const locale =
    (shouldTakeCookieFromRequestHeaders ? getLocaleFromRequestCookieHeaders(request.headers) : getLocaleFromCookie()) ??
    i18nConfig.defaultLocale;

  const languageId = LANGUAGE_ID_BY_LOCALE[locale] ?? LANGUAGE_ID_BY_LOCALE[i18nConfig.defaultLocale];

  request.headers.set(LANGUAGE_ID_HEADER_NAME, languageId);
};

/**
 * Can be used in "Server Components" or during SSR to get the current `locale`.
 * Based on custom header: `I18N_ROUTER_LOCALE_HEADER_NAME`
 */
export const getLocaleFromHeaders = (headers: Headers, fallbackLocale = i18nConfig.defaultLocale) => {
  const currentLocale = headers.get(I18N_ROUTER_LOCALE_HEADER_NAME);
  return currentLocale || fallbackLocale;
};
